import { observer } from "mobx-react-lite";
import React, { useContext, createContext } from "react";
import { queryStringStore } from "./wsQueryStringStore";

export const useSearchParam = (param: string) => {
  return useContext(SearchParamContext)[param]?.toString();
};

const SearchParamContext = createContext<{ [key: string]: string }>({});

export const SearchParamProvider = observer(({ children }) => {
  return (
    <SearchParamContext.Provider value={queryStringStore.qs}>
      {children}
    </SearchParamContext.Provider>
  );
});
